



























import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LdapImportModal extends Vue {
  private ldapImport: any = null
  private accountId: string | null = null

  show(ldapImport: any, accountId?: string) {
    this.ldapImport = ldapImport
    this.accountId = accountId || null
    const modal = this.$refs.modal as any
    if (modal) {
      modal.show()
    }
  }

  hide() {
    const modal = this.$refs.modal as any
    if (modal) {
      modal.hide()
    }
  }

  onHidden() {
    this.ldapImport = null
    this.accountId = null
  }
}
